import React from "react"
import PropTypes from "prop-types"
import { TopSkill, SkillName, SkillQualifications, Skill, SkillLevel } from "./styles"
import Autolink from "../../autolink"
import Grid from "../../grid"
import { H2, P } from "../../typography"

const Qualifications = (skill) => (
  <SkillQualifications>
    {skill.qualifications?.map((qualification, index) => {
      const { qualification_name, certificate_body_name, year_awarded } = qualification
      const qualificationDetails = [qualification_name, certificate_body_name, year_awarded].filter(Boolean).join(", ")
      return (
        <P key={index} profileData marginless>
          {qualificationDetails}
        </P>
      )
    })}
  </SkillQualifications>
)

const Skills = ({ top_skills, other_skills, portalType }) => (
  <>
    <H2 variant="primary" profile>
      Skills
    </H2>

    {top_skills.length > 0 || other_skills.length > 0 ? (
      <Grid gap="24px">
        {top_skills.map((skill, _index) => (
          <Skill key={skill.id}>
            <Grid gap="16px">
              <SkillName>
                <H2 marginless variant="secondary" profile>
                  {skill.name}
                  {portalType === "employer" && skill.level?.length > 0 && <SkillLevel> - {skill.level}</SkillLevel>}
                </H2>
                <TopSkill>Top skill</TopSkill>
              </SkillName>

              {portalType !== "employer" && (
                <Grid gap="4px">
                  <P marginless profileLabel>
                    Level
                  </P>
                  <P marginless profileData>
                    {skill.level || "-"}
                  </P>
                </Grid>
              )}

              {skill.qualifications?.length > 0 && (
                <Grid gap="4px">
                  <P marginless profileLabel>
                    Qualification Acquired
                  </P>
                  <P marginless profileData variant="contentv2" overflow>
                    {Qualifications(skill)}
                  </P>
                </Grid>
              )}

              <P marginless variant="contentv2" multiline overflow>
                <Autolink text={skill.description || "-"} />
              </P>
            </Grid>
          </Skill>
        ))}
        {other_skills.map((skill, index) => (
          <Skill key={skill.id}>
            <Grid gap="16px">
              <H2 marginless variant="secondary" profile>
                {skill.name}
                {portalType === "employer" && skill.level?.length > 0 && <SkillLevel> - {skill.level}</SkillLevel>}
              </H2>

              {portalType !== "employer" && (
                <Grid gap="4px">
                  <P marginless profileLabel>
                    Level
                  </P>
                  <P marginless profileData>
                    {skill.level || "-"}
                  </P>
                </Grid>
              )}

              {skill.qualifications?.length > 0 && (
                <Grid gap="4px">
                  <P marginless profileLabel>
                    Qualification Acquired
                  </P>
                  <P marginless profileData>
                    {Qualifications(skill)}
                  </P>
                </Grid>
              )}

              <P marginless variant="contentv2" multiline overflow>
                <Autolink text={skill.description || "-"} />
              </P>
            </Grid>
          </Skill>
        ))}
      </Grid>
    ) : (
      <P marginless profileData>
        No skills set.
      </P>
    )}
  </>
)

Skills.propTypes = {
  top_skills: PropTypes.array.isRequired,
  other_skills: PropTypes.array.isRequired
}

Skills.defaultProps = {
  top_skills: [],
  other_skills: []
}

export default Skills
